import React, {useEffect, useState} from 'react';
import Button from "react-bootstrap/Button";
import InputCddGPEmpDiscussionModal from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionModal";
import DVTJCUVSearchCddJobOverviewModal from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobOverviewModal";
import * as CandidateService from "@app/services/CandidateService";
import {ResponseCode} from "@app/constants/Common";
import {convertVNDateTimeToDate} from "@app/utils/DateTimeUtils";
import {ServiceStatuses} from "@pages/candidate/detail/CandidateDVTJCUV";
import DVTJCUVSearchJobExcludeReceiverModal
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchJobExcludeReceiverModal";
import DVTJCUVSearchJobExcludeEmployerModal
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchJobExcludeEmployerModal";
import {showMessage} from "@app/constants/Messages";


const DVTJCUVSearchCddJobHeader = (props) => {
    const [cdd, setCdd] = useState({});
    const [showInputCddGPEmpDiscussionModal, setShowInputCddGPEmpDiscussionModal] = useState(false);
    const [showOverviewModal, setShowOverviewModal] = useState(false);
    const [showExcludeReceiverModal, setShowExcludeReceiverModal] = useState(false);
    const [showExcludeEmployerModal, setShowExcludeEmployerModal] = useState(false);
    const [currentUseTime, setCurrentUseTime] = useState({});
    const {cddInfo} = props

    const fetchCandidateDVTJCUV = async (canId) => {
        const res = await CandidateService.requestGetCandidateDVTJCUV(canId)
        if (res.sts_code === ResponseCode.SUCCESS) {
            const useTimes = res.content.clients
            if (useTimes.length > 0) {
                const currUseTime = {...useTimes[0]}
                const status = Object.values(ServiceStatuses).find(
                    item => item.id === currUseTime.service_status
                );

                currUseTime.service_status_name = status ? status.title : '';
                // currUseTimes.expiry_date_time = convertVNDateTimeToDate(currUseTimes.expiry_date_time)
                // currUseTimes.expiry_date_time = currUseTimes.expiry_date_time.toISOString().slice(0, 10)
                setCurrentUseTime(currUseTime)
            }
        }
    };

    useEffect(() => {
        if (cddInfo) {
            setCdd(cddInfo)
            fetchCandidateDVTJCUV(cddInfo.id)
        }
    }, [cddInfo])

    const createHeader = () => {
        return [
            cdd.id
            , cdd.full_name
            , cdd.displayed_company
            , cdd.displayed_title
            , cdd.local_province_email
            , cdd.industry
            , cdd.function
        ].filter(
            item => item !== null
                && item !== undefined && item !== ""
        ).join(" | ")
    }

    const onInputGPEmpDiscussion = () => {
        setShowInputCddGPEmpDiscussionModal(true)
    }

    const onOverview = () => {
        setShowOverviewModal(true)
    }

    const onOpenExcludeReceiverModal = () => {
        setShowExcludeReceiverModal(true)
    }

    return (
        <>
            <div className="card-header">
                <h3 className="card-title text-bold">Cdd ID: {createHeader()}</h3>
                <div className="card-tools pr-2">
                    <div className={'row float-right'}>
                        <div className="btn-group ml-2">
                            <Button onClick={() => onOverview()}
                                    className={"btn btn-sm btn-default"}>Overview
                            </Button>
                        </div>
                        <div className="btn-group ml-2">
                            <a href={`/dvtjcuv/list?cddId=${cdd.id || ''}`}
                               target={'_blank'}
                               rel="noopener noreferrer"
                               className={'btn btn-sm btn-default'}>
                                Pipeline history
                            </a>
                        </div>
                        <Button variant='info' onClick={() => onInputGPEmpDiscussion()} className={'btn-sm ml-3'}>
                            Nhập Cdd-GP-Emp Discussion
                        </Button>
                        <Button onClick={() => onOpenExcludeReceiverModal()}
                                className={'btn btn-sm btn-default ml-3'}>
                            Receiver bị loại trừ [0]
                        </Button>
                        <Button onClick={() => {setShowExcludeEmployerModal(true)}}
                                className={'btn btn-sm btn-default ml-3'}>
                            Employers bị loại trừ [0]
                        </Button>
                    </div>
                </div>

                <h3 className="card-title text-bold ml-lg-5">Lần SDDV : {currentUseTime.service_use_times}</h3>
                <h3 className="card-title text-bold ml-lg-5">Trạng thái SDDV : {currentUseTime.service_status_name}</h3>
            </div>

            {showOverviewModal &&
                <DVTJCUVSearchCddJobOverviewModal
                    isShow={showOverviewModal}
                    cddId={cdd.id}
                    onClose={() => setShowOverviewModal(false)} />
            }

            {showInputCddGPEmpDiscussionModal &&
                <InputCddGPEmpDiscussionModal
                    pipelineInfo={{cdd_id: cdd.id}}
                    onClose={(success) => {
                        if (success) {
                            showMessage("Đã lưu Cdd-GP-Emp Discussion thành công.", false, true);
                        }
                        setShowInputCddGPEmpDiscussionModal(false);
                    }}
                    isShow={showInputCddGPEmpDiscussionModal} />
            }

            {showExcludeReceiverModal &&
                <DVTJCUVSearchJobExcludeReceiverModal
                    cddId={cdd.id}
                    onClose={() => setShowExcludeReceiverModal(false)}
                    isShow={showExcludeReceiverModal} />
            }

            {showExcludeEmployerModal &&
                <DVTJCUVSearchJobExcludeEmployerModal
                    cddId={cdd.id}
                    onClose={() => setShowExcludeEmployerModal(false)}
                    isShow={showExcludeEmployerModal} />
            }
        </>
    )
}

export default DVTJCUVSearchCddJobHeader;
